import { render } from "./VirtualMeetingEditPane.vue?vue&type=template&id=e0cdd778&scoped=true&ts=true"
import script from "./VirtualMeetingEditPane.vue?vue&type=script&lang=ts"
export * from "./VirtualMeetingEditPane.vue?vue&type=script&lang=ts"

import "./VirtualMeetingEditPane.vue?vue&type=style&index=0&id=e0cdd778&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0cdd778"]])

export default __exports__